<template>
  <svg version="1.1" class="svgicon" v-bind:class="[className, (type === 'full') ? 'svgicon--full' : false]">
    <use v-bind:xlink:href="`#${name}`" />
  </svg>
</template>

<script>
export default {
  props: {
    name: {
      required: true,
      default: 'icon'
    },
    type: {
      default: false
    },
    className: {
      default: ''
    }
  }
}
</script>
